import { useState } from 'react';

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  function toggle() {
    setIsShowing((showing) => !showing);
  }

  function hide() {
    setIsShowing(false);
  }

  function show() {
    setIsShowing(true);
  }

  return {
    isShowing,
    toggle,
    show,
    hide,
  };
};

export default useModal;
